import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadButtonComponent } from './components/file-upload-button/file-upload-button.component';
import { IconModule } from '../icon/icon.module';

@NgModule({
  declarations: [FileUploadButtonComponent],
  imports: [CommonModule, IconModule],
  exports: [FileUploadButtonComponent],
})
export class FileUploadButtonModule {}
